<template>
  <div style="padding: 20px">
    <WmsTable
      :columns="columns"
      :dataSource="[detail]"
      :isPagination="false"
      :hasHeader="false"
    >
    
    <div slot="tag"  slot-scope="{text,record}">
        <div v-if="record.oemMoreInboundException">
          <div v-for="item in record.processResults">{{ `${item.amount}件${item.flowTagName}(${item.pkgCode})` }}</div>
        </div>
        <div v-else-if="record.tag">
          {{ taglist[taglist.findIndex(i=>i.value == record.tag)].label }}
        </div>
        <div v-else></div>
      </div>
    </WmsTable>
    <div style="text-align: left" v-if="detail.imgs">图片</div>
    <div style="display: flex" class="abnormalImage" v-if="detail.imgs">
      <div v-for="(item,index) in detail.imgDTOList" :key="index" style="width: 100px;position: relative;margin-right: 10px;">
        <el-image
            :src="item.image"
            :style="imgStyle"
            :preview-src-list="[item.image]"
            alt="图片"
            style="width: 100px;">
        </el-image>

        <div class="tag-side-content">
          <div v-if="item.tags?.includes('outside')" class="tag-item">表面</div>
          <div v-if="item.tags?.includes('inside')" class="tag-item">内里</div>
          <div v-if="item.tags?.includes('normal')" class="tag-item">正品</div>
          <div v-if="item.tags?.includes('defective')" class="tag-item">次品</div>
        </div>
      </div>
      <!-- <ImgPreviews
        v-for="item in detail.imgs"
        :key="item"
        :images="[item]"
      ></ImgPreviews> -->
    </div>
    <div style="text-align: left">处理</div>
    <div style="text-align: left">
      <el-form :model="detail" class="demo-form-inline">
        <el-form-item label="备注:">
          <el-input
            v-model="detail.remark"
            placeholder="输入备注"
            type="textarea"
          ></el-input>
        </el-form-item>
        <el-form-item label="关联新采购单:">
          <div @click="toInHouse_check">{{ detail.purchaseNew || "无" }}</div>
        </el-form-item>
      </el-form>
    </div>
    <div style="text-align: right" v-if="detail.wareStatus != 1">
      <el-button @click="solve" type="primary">已解决</el-button>
      <el-button @click="submit" type="primary">保存备注</el-button>
    </div>
  </div>
</template>

<script>
import WmsTable from "@/components/WmsTable";
import ImgPreviews from "@/components/ImgPreviews";
import { columns } from "@/views/abnormal/listDetail/columns";
import { wareDealFlow } from "@/apis/abnormal";
import { taglist } from "@/views/abnormal/list/columns";
export default {
  name: "abnormal_listDetail",
  components: { WmsTable, ImgPreviews },
  data() {
    return {
      columns,
      taglist,
      detail: {},
      query: {
        current: 1,
        pageNum: 20,
      },
    };
  },
  mounted() {},
  methods: {
    toInHouse_check() {
      // this.detail.purchaseNew = 12345
      if(!this.detail.purchaseNew){
        return
      }
      this.$emit('close')
      this.$router.push({path:'/inHouse_check',query:{purchaseNew:this.detail.purchaseNew}})
    },
    solve() {
      let params = {
        flowCode: this.detail.flowCode,
        wareStatus: 1,
      };
      wareDealFlow(params).then(({ code, data }) => {
        if (code === 0) {
          this.$message.success("成功");
          this.$emit("reFreash");
        }
      });
    },
    submit() {
      if(!this.detail.remark){
        this.$message.error('请输入备注')
        return
      }
      let params = {
        remark: this.detail.remark,
        flowCode: this.detail.flowCode,
      };
      wareDealFlow(params).then(({ code, data }) => {
        if (code === 0) {
          this.$message.success("成功");
          this.$emit('close')
        }
      });
    },
  },
};
</script>

<style scoped>
.abnormalImage {
  display: flex;
}
</style>
